<template>
  <div class="BBSEditDiv">
    <label class="BBSEditHeader">{{ i18n.$t('BBSEditHeader') }}</label>
    <van-field class="BBSEditTitle" v-model="BBSEditTitle" label="" :placeholder="i18n.$t('BBSEditTitle')" />
    <tinymce-editor
        ref="editor"
        class="BBSEditContent"
        v-model="BBSEditContent"
        :value="BBSEditContent"
        @input="handleInput"
        :disabled="disabled"
        @onClick="onClick"
    >
    </tinymce-editor>
    <div class="BBSEditTypeDiv">
        <label class="BBSEditTypeTitle">{{ i18n.$t('BBSEditTypeTitle') }}</label><br>
        <a-select
            v-model:value="BBSEditType"
            show-search
            placeholder="Select a type"
            option-filter-prop="children"
            style="width: 200px;margin-top:10px;"
        >
            <a-select-option v-for="(item,index) in BBSEditTypeList" :key="index" :value="item">
            {{ item }}
            </a-select-option>
            <!-- <a-select-option :value="i18n.$t('BBSEditTypeDownload')">{{ i18n.$t('BBSEditTypeDownload') }}</a-select-option>
            <a-select-option :value="i18n.$t('BBSEditTypeCheck')">{{ i18n.$t('BBSEditTypeCheck') }}</a-select-option>
            <a-select-option :value="i18n.$t('BBSEditTypeWriteNumber')">{{ i18n.$t('BBSEditTypeWriteNumber') }}</a-select-option>
            <a-select-option :value="i18n.$t('BBSEditTypePlateform')">{{ i18n.$t('BBSEditTypePlateform') }}</a-select-option>
            <a-select-option :value="i18n.$t('BBSEditTypeOther')">{{ i18n.$t('BBSEditTypeOther') }}</a-select-option> -->
        </a-select>
    </div>
    <div class="BBSEditErrorCodeDiv">
        <label class="BBSEditErrorCodeTitle">{{ i18n.$t('BBSEditErrorCodeTitle') }}</label><br>
        <a-input class="BBSEditErrorCodeInput" v-model:value="BBSEditErrorCode"/>
    </div>
    <div class="BBSEditButtonDiv">
        <img class="BBSEditButton" @click="AddBBS()" src="@/assets/svg/botton_发表.svg">
        <img class="BBSEditButton" @click="GoBack()" src="@/assets/svg/botton_取消.svg">
    </div>
  </div>
</template>

<script>
import { useI18n } from "@/i18nPlugin";
import { message } from 'ant-design-vue';
import { defineComponent, ref } from "vue";
import { useRouter } from 'vue-router';
import { 
    SearchBBSDetailData,
    AddBBSData,
    EditBBSData,
    SearchBBSTagsData
} from '../api/index';
import TinymceEditor from "@/components/tinymce-editor/tinymce-editor";
export default defineComponent({
  components: {
    TinymceEditor,
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const token = localStorage.getItem("userToken");
    const BBSEditTypeList = ref([]);
    const BBSEditTitle = ref("");
    const BBSEditType = ref("");
    const BBSEditErrorCode = ref("");
    const BBSEditContent = ref("");
    const handleInput = (value) => {
      BBSEditContent.value = value;
    //   console.log(value);
    };
    // 鼠标单击的事件
    const onClick = (e, editor) => {
    //   console.log("Element clicked");
    //   console.log(e);
    //   console.log(editor);
    };
    const SearchBBSTags = () => {
        SearchBBSTagsData (token).then(res => {
            BBSEditTypeList.value = res.data;
            // console.log(res.data)
        }).catch(error => {
            console.log(error)
        });
    }
    const SearchBBSDetail = () => {
        SearchBBSDetailData ({
            id: EditId
        }).then(res => {
            BBSEditTitle.value = res.data.title;
            BBSEditContent.value = res.data.content;
            BBSEditType.value = res.data.tag;
            // console.log(res)
        }).catch(error => {
            console.log(error)
        });
    }
    const AddBBS = () => {
        // console.log(BBSEditType.value)
        if(BBSEditTitle.value == '' || BBSEditContent.value == '' || BBSEditType.value == '') {
            message.error(i18n.$t('BBSEditMessage'));
            return false;
        }else {
            if(EditId != false) {
                // console.log(EditId,"id")
                EditBBSData ({
                    id: EditId,
                    title: BBSEditTitle._rawValue,
                    content: BBSEditContent._rawValue,
                    tag: BBSEditType._rawValue,
                    errorCode: BBSEditErrorCode._rawValue,
                },token).then(res => {
                    if(res.status == 200){
                        router.push({ path: '/ATS/PersonalCenter', query: { type: "Question" }});
                    }
                }).catch(error => {
                    // this.$message.danger('添加失败');
                    console.log(error);
                })
            }else{
                AddBBSData ({
                    title: BBSEditTitle._rawValue,
                    content: BBSEditContent._rawValue,
                    tag: BBSEditType._rawValue,
                    errorCode: BBSEditErrorCode._rawValue,
                },token).then(res => {
                    if(res.status == 200){
                        router.push({ path: '/ATS/BBS'});
                    }
                }).catch(error => {
                    // this.$message.danger('添加失败');
                    console.log(error);
                })
            }
        }
    }

    const  getQueryVariable = (variable) =>{
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }

    const EditId = getQueryVariable("id");

    const GoBack = () => {
        history.go(-1);
    }

    return { 
        i18n,
        token,
        BBSEditTitle,
        BBSEditType,
        BBSEditErrorCode,
        BBSEditTypeList,
        BBSEditContent,
        EditId,
        handleInput,
        SearchBBSDetail,
        getQueryVariable,
        SearchBBSTags,
        onClick,
        AddBBS,
        GoBack
    };
  },
  mounted() {
    //   alert(this.EditId)
      if(this.EditId != false) {
          this.SearchBBSDetail();
      }
      this.SearchBBSTags();
  }
});
</script>

<style lang="less" scoped>
.BBSEditDiv {
    padding: 30px 50px;
    text-align: left;
    .BBSEditHeader {
        font-size: 16px;
        font-weight: bold;
    }
    .BBSEditTitle {
        margin-top: 15px;
        border:  1px solid #D7D7D7;
    }
    .BBSEditContent {
        margin-top: 15px;
    }
    .BBSEditTypeTitle {
        font-weight: bold;
        font-size: 14px;
    }
    .BBSEditTypeDiv {
        margin-top: 20px;
    }
    .BBSEditType {
        margin-top: 20px;
    }
    .BBSEditErrorCodeTitle {
        font-weight: bold;
        font-size: 14px;
    }
    .BBSEditErrorCodeDiv {
        margin-top: 20px;
    }
    .BBSEditErrorCode {
        margin-top: 20px;
    }
    .BBSEditErrorCodeInput {
        width: 200px;
        margin-top: 15px;
        border:  1px solid #D7D7D7;
    }
    .BBSEditButtonDiv {
        margin-top: 20px;
    }
    .BBSEditButton {
        cursor: pointer;
        width: 125px;
        height: 35px;
        margin-left: 20px;
        margin-bottom: 20px;
        float: right;
    }
}
</style>